import * as React from 'react';
import { Link } from 'react-router-dom';
import { SortableHandle, SortableContainer, SortableElement } from 'react-sortable-hoc';
import NoRecords from './../Shared/NoRecords';
import { Module } from 'src/models/module';
import { MODULE_TYPES } from 'src/globals';

const DragHandle = SortableHandle(() => {
  return (
    <div className="text-center" style={{ cursor: 'move' }}>
      <i className="fa fa-hand-grab-o fa-2x"></i>
    </div>
  );
});

const ModuleRow = SortableElement(
  ({ module, onDelete }: { module: Module, onDelete: any }) => {
    return (
      <div className="card mb-2">
        <div className="card-body">
          <div className="row">
            <div className="col-md-2">
              #{module.id} - {MODULE_TYPES[module.type!].toUpperCase()}
            </div>
            <div className="col-md-5">
              {module.translations.es.title}
            </div>
            <div className="col-md-2">
              <b>Posicion</b>: {module.position}
            </div>
            <div className="col-md-1">
              <Link
                className="btn btn-dark btn-block btn-sm"
                to={`/modulos/${module.content_id}/editar/${module.id}`}
              >
                Editar
              </Link>
            </div>
            <div className="col-md-1">
              <button
                className="btn btn-danger btn-block btn-sm"
                type="button"
                onClick={() => onDelete(module.id)}
              >
                Eliminar
              </button>
            </div>
            <div className="col-md-1">
              <DragHandle />
            </div>
          </div>
        </div>
      </div>
    );
  });

const ModuleTable = SortableContainer(
  ({ modules, onDelete }: { modules: Module[], onDelete: any }) => {
    return (
      <div>
        {
          modules.map((m: Module, i: number) => {
            return (
              <ModuleRow key={i} {...{ onDelete, module: m, index: i }}/>
            );
          })
        }
      </div>
    );
  });

const ModuleList = (
  { modules, contentId, onDelete, onSortEnd }:
  { modules: Module[], contentId: number, onDelete: any, onSortEnd: any }
) => {
  return (
    <div className="card mb-5">
      <div className="card-header bg-primary text-white">
        <h3 className="mb-0">
          <i className="fa fa-th"></i> Modulos
          <div className="pull-right">
            <Link className="btn btn-light" to={`/editar/${contentId}`}>
              <i className="fa fa-pencil"></i> Contenido
            </Link>
            &nbsp;
            <Link className="btn btn-light pull-right" to={`/modulos/${contentId}/crear`}>
              <i className="fa fa-plus-circle"></i> Crear
            </Link>
          </div>
        </h3>
      </div>
      <div className="card-body">
        {
          !modules || !modules.length
          ? <NoRecords />
          : <ModuleTable {...{ modules, onDelete, onSortEnd, useDragHandle: true }}/>
        }
      </div>
    </div>
  );
}

export default ModuleList;



// WEBPACK FOOTER //
// ./src/components/Module/list.tsx